/**
 * Copyright 2025 John Huikku Alienrobot LLC
 * www.ALIENROBOT.com
 */

import { OPENROUTER_MODELS } from '@/providers/llm-provider'

/**
 * Get human-readable model display name from model ID
 * Falls back to model ID if not found in catalog
 */
export function getModelName(modelId: string | undefined): string {
  if (!modelId) return ''
  const model = OPENROUTER_MODELS.find(m => m.id === modelId)
  return model ? model.name : modelId
}

